import { useCallback, useState } from 'react';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISearchInput from 'UIComponents/input/UISearchInput';
import withUsageTracking from '../hoc/withUsageTracking';
import EPFullscreenOverlay from './EPFullscreenOverlay';
import EPAnimatedSearchBox from './EPAnimatedSearchBox';
import { useCategorizedSuggestions } from './utils';
import EPSpotlightCategory from './EPSpotlightCategory';
import EPSpotlightSuggestion from './EPSpotlightSuggestion';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EPSpotlight = ({
  label = I18n.text('epSpotlight.label'),
  maxSuggestions = 10,
  onClose,
  onTrackUsage,
  placeholder = I18n.text('epSpotlight.placeholder'),
  suggestions
}) => {
  const [inputValue, setInputValue] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onSearchChange = useCallback(evt => {
    setInputValue(evt.target.value);
    setSelectedIndex(0);
  }, []);
  const onClickSuggestion = useCallback(suggestion => {
    const {
      category,
      id,
      onRun
    } = suggestion;
    onTrackUsage('Chose QuickSpot suggestion', {
      suggestionCategory: category,
      id
    });
    onClose();
    onRun();
  }, [onClose, onTrackUsage]);
  const {
    categorizedSuggestions,
    orderedSuggestions,
    total
  } = useCategorizedSuggestions(suggestions, inputValue, maxSuggestions);
  const categorizedSuggestionsEntries = Object.entries(categorizedSuggestions);
  const selectedSuggestion = orderedSuggestions[selectedIndex];
  const handleArrowNavigation = evt => {
    if (evt.key === 'ArrowUp' && selectedIndex > 0) {
      evt.preventDefault();
      setSelectedIndex(selectedIndex - 1);
    } else if (evt.key === 'ArrowDown' && selectedIndex < total - 1) {
      evt.preventDefault();
      setSelectedIndex(selectedIndex + 1);
    } else if (evt.key === 'Enter' && total > 0) {
      evt.preventDefault();
      onClickSuggestion(selectedSuggestion);
    }
  };
  return /*#__PURE__*/_jsx(EPFullscreenOverlay, {
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(EPAnimatedSearchBox, {
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": label,
        children: /*#__PURE__*/_jsx(UISearchInput, {
          autoFocus: true,
          className: "p-x-3",
          onChange: onSearchChange,
          onKeyDown: handleArrowNavigation,
          placeholder: placeholder,
          styled: false
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-x-2",
        style: {
          borderTop: `1px solid ${GREAT_WHITE}`
        },
        children: categorizedSuggestionsEntries.length ? categorizedSuggestionsEntries.map(([category, suggestionsByCategory]) => /*#__PURE__*/_jsx(EPSpotlightCategory, {
          category: category,
          children: suggestionsByCategory.map(suggestion => /*#__PURE__*/_jsx(EPSpotlightSuggestion, {
            isSelected: suggestion.id === selectedSuggestion.id,
            onClick: onClickSuggestion,
            suggestion: suggestion
          }, suggestion.id))
        }, category)) : /*#__PURE__*/_jsx(UIResultsMessage, {
          illustration: "empty-state-charts",
          illustrationProps: {
            width: 200
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "epSpotlight.noResultsText",
            options: {
              search: inputValue
            }
          })
        })
      })]
    })
  });
};
export default withUsageTracking(EPSpotlight);